import { render } from "./TableQRCode.vue?vue&type=template&id=b1a5cf6a"
import script from "./TableQRCode.vue?vue&type=script&lang=js"
export * from "./TableQRCode.vue?vue&type=script&lang=js"

import "./TableQRCode.vue?vue&type=style&index=0&id=b1a5cf6a&lang=less"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__